import OutlierDetectorEditDto from './OutlierDetectorEditDto';

export class LocalOutlierFactorModelEditDto extends OutlierDetectorEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.n_neighbours = 50;
		/** @type {number} */
		this.contamination = 0.1;
		/** @type {boolean} */
		this.novelty = true;
	}

	/**
	 * @typedef {Object} _LocalOutlierFactorModelEditDtoProps
	 * @property {number} n_neighbours
	 * @property {number} contamination
	 * @property {boolean} novelty
	 *
	 * @typedef {import("./OutlierDetectorEditDto").OutlierDetectorEditDtoProps & _LocalOutlierFactorModelEditDtoProps} LocalOutlierFactorModelEditDtoProps
	 */
	/**
	 *
	 * @param {LocalOutlierFactorModelEditDtoProps} props
	 * @returns {LocalOutlierFactorModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.n_neighbours = props.n_neighbours;
		this.contamination = props.contamination;
		this.novelty = props.novelty;
		return this;
	}
}

export default LocalOutlierFactorModelEditDto;